package game.string

var stringsEn = mapOf<String, String>(
    // General strings
    "Title" to "Godlair",
    "Copyright" to "Copyright (C) 2021 Chronogears Inc.",
    "Title_Tag" to "A CGA Textmode Adventure",
    "FullTitle" to "Godlair: A CGA Textmode Adventure",

    // Title
    "Title_NewGame" to "New Game",
    "Title_Settings" to "Settings",
    "Title_DeleteGame" to "Delete Game",
    "Title_CancelDelete" to "Cancel",
    "Title_Empty" to "Empty",

    // Setting controllers
    "Settings_Sound" to "Sound",
    "Settings_SoundOn" to "On",
    "Settings_SoundOff" to "Mute",
    "Settings_Keyboard" to "Keyboard Layout",
    "Settings_Language" to "Language",
    "Settings_QuitTitle" to "Return to Title",
    "Settings_QuitDesktop" to "Exit Godlair",

    // Dialog
    "Dialog_Start" to "A trap opened at your feet and you fell into the UNDERREALM. Many more trials await you. But fear not, the game saves everytime you change room. If you die, try again. You'll get there in the end. Now, venture forth!",
    "Dialog_CloseMessage" to "Press SPACE or click anywhere to continue",
    "Dialog_Dark" to "It's much too dark here. You need a light source before you can venture forth. Go back.",

    // Item dialog
    "Dialog_Lens" to "You have founds the LENS left to you by your father. This will allow you to see yellow WISHSHARDS. Collect 1000 and your deepest wish will come true. But beware of the many traps and trials that await inside.",
    "Dialog_Map" to "You have found an magical map of Godlair. It will fill up as you explore rooms. Click Map or press M to open the map.",
    "Dialog_Light1" to "You found the CANDLE. This will allow you to explore the dark corners of Godlair.",
    "Dialog_Light2" to "",
    "Dialog_Light2Alternate" to "",
    "Dialog_Light3" to "You have found the lantern created by an ancient race of realm-travelers. The darkness retreats even farther away from you.",
    "Dialog_Weapon1" to "There are many sticks lying about, but none are as perfectly smooth and straight as this one. You feel the urge to bash things with this stick. Click Hit or press SPACE to hit things.",
    "Dialog_Weapon2" to "You have found an old but well crafted sword. You can now break strong pots.",
    "Dialog_Bracer1" to "You found the CLOTH BRACER! As you wrap it around your wrists, you feel strength flowing in your arms. You can now push heavy things.",
    "Dialog_Jump1" to "A strangle mechanical contraption composed of springs and gears fits around your legs. With it, you are now able to jump short distances. Go ahead and try it! Walk up to a pit. What could go wrong?",
    "Dialog_Jump2" to "You have found the Weaver's masterpiece: the CAPE. You suddenly feel lighter as you drape it over your shoulders. You are now able to jump twice as far over pits.",
    "Dialog_SpeedUp1" to "",
    "Dialog_SpeedUp1Alternate" to "",
    "Dialog_SpeedUp2" to "",

    // Tips:
    "Tip_L1R42" to "Welcome to the Olympiad. If you can't take the heat, don't even think of running the length of the lava raceway.",

    // Sidebar
    "SideBar_Location" to "Location",
    "SideBar_Life" to "Life:",
    "SideBar_Shards" to "Shards:",

    // Button
    "Button_Map" to "Map",
    "Button_Menu" to "Menu",
    "Button_Hit" to "Hit",

    // Map levels
    "Map_Level0" to "Godlair",
    "Map_Level1" to "Old Kingdom",
    "Map_Level2" to "Underrealm",

    // Tips
    "Tip_Dark" to "It's dark up ahead. Make sure you have a light with you.",
    "Tip_Ice" to "Slippery ice up ahead.",

    // Messages
    "Message_Jump" to "I can't jump that far",
    "Message_Swim" to "I wish I could swim",
    "Message_Lava" to "The floor is lava!",
    "Message_TooHeavy" to "I can't push this",
    "Message_Pot" to "I can't break this pot",
    "Message_PotHit" to "I should smash this pot",
    "Message_Door" to "It won't open!!!",
    "Message_SpawnCount" to "%n imps remaining",
    "Message_Victory" to "Victory!",
    "Message_FullHealth" to "I'm at full health",

    // Walls
    "Message_Door_ShardCount" to "Need %n shards to open",

    "Message_Wall_Tree" to "There's a tree in my way",
    "Message_Wall_Boulder" to "There's a boulder blocking my way",
    "Message_Wall_StoneWall" to "There a stone wall in my way",
    "Message_Wall_Column" to "There's a column carved out of stone",
    "Message_Wall_Wall" to "There's a wall in my way",
    "Message_Wall_Generic" to "I can't go there",


    // Rooms
    "outdoors-1_Name" to "Forest",
    "outdoors-1_Lore" to "",
    "outdoors-2_Name" to "Foot of the Mountain",
    "outdoors-2_Lore" to "",
    "entrance_Name" to "Godlair Entrance",
    "entrance_Lore" to "Godlair Entrance",
    "lobby_Name" to "Godlair Lobby",
    "lobby_Lore" to "Godlair Lobby",
    // Room L1R00
    "L1R00_Name" to "Store Room",
    "L1R00_Lore" to "",
    // Room L1R10
    "L1R10_Name" to "Kitchen",
    "L1R10_Lore" to "",
    // Room L1R20
    "L1R20_Name" to "Dining",
    "L1R20_Lore" to "",
    // Room L1R30
    "L1R30_Name" to "Lounge",
    "L1R30_Lore" to "",
    // Room L1R40
    "L1R40_Name" to "Aquifer",
    "L1R40_Lore" to "This was the source of water for the old city. It started as a small stream but men dug into the cave wall to enlarge the stream. As they did so, they exposed the stream to corrupted vein of heavy metals, rendering the once pure water into a toxic concoction.",
    // Room L1R50
    "L1R50_Name" to "Blighted Swamp",
    "L1R50_Lore" to "When the canal was dug to build the port, the water in this region became disease ridden.",
    // Room L1R60
    "L1R60_Name" to "Recluse",
    "L1R60_Lore" to "",
    // Room L1R70
    "L1R70_Name" to "Old Port",
    "L1R70_Lore" to "",
    // Room L1R80
    "L1R80_Name" to "Cursed Sill",
    "L1R80_Lore" to "",
    // Room L1R01
    "L1R01_Name" to "Old Market",
    "L1R01_Lore" to "",
    // Room L1R11
    "L1R11_Name" to "Weaver Conclave",
    "L1R11_Lore" to "Long ago, weavers discovered that cloth could be imbued with special properties. The secret of such capabilities was protected by an ancient conclave of weavers, passed down from master to disciple. What powers did those ancient weaves have?",
    // Room L1R21
    "L1R21_Name" to "Cold Ponds",
    "L1R21_Lore" to "",
    // Room L1R31
    "L1R31_Name" to "Icy Streams",
    "L1R31_Lore" to "",
    // Room L1R41
    "L1R41_Name" to "Festering Falls",
    "L1R41_Lore" to "",
    // Room L1R51
    "L1R51_Name" to "Uncharted Pits",
    "L1R51_Lore" to "To this day, it remains unclear who created those pits and why. The few that dared to chart them never returned from the dark depth below.",
    // Room L1R61
    "L1R61_Name" to "Kraken Den",
    "L1R61_Lore" to "Two centuries ago, a great storm blew so much sand that the sea was cut off and became this lake. A lone kraken was trapped in this lake and terrorizes all who approach.",
    // Room L1R71
    "L1R71_Name" to "Lonesome Dock",
    "L1R71_Lore" to "Not long ago, a wise old man would fish here. He befriended the kraken that lives in this lake. Unfortunately, his only legacy are now ancient blood stains.",
    // Room L1R81
    "L1R81_Name" to "Burrow Leading",
    "L1R81_Lore" to "Imps often crawl out of the Underrealm from here. Many attempts were made over centuries to block the burrow leading but the imps always manage to dig a new leading.",
    // Room L1R02
    "L1R02_Name" to "Rock Forest",
    "L1R02_Lore" to "",
    // Room L1R12
    "L1R12_Name" to "Pitted Hall",
    "L1R12_Lore" to "Nobles and their retainers lived here until dark creatures from the Underrealm carved and crawled out of pits, slaughtering all in their path and looting--leaving only the skeleton of a one prestigious mansion",
    // Room L1R22
    "L1R22_Name" to "Echoes of Treason",
    "L1R22_Lore" to "",
    // Room L1R32
    "L1R32_Name" to "Deus Morten",
    "L1R32_Lore" to "Ancient vicious gods who were angry at being awoken smote and destroyed an entire race of amphibious creatures. As they departed from the mortal realm, a sword was left behind--forgotten or abandoned.",
    // Room L1R42
    "L1R42_Name" to "Olympiad",
    "L1R42_Lore" to "A thousand years ago, an attempt was made to unite all sentient races in peace. Games were organized but quickly turned bloody as old prejudice prevented the races from working together.",
    // Room L1R52
    "L1R52_Name" to "Great Stairway",
    "L1R52_Lore" to "This is the entrance to Godlair, sought by many, found by a few.",
    // Room L1R62
    "L1R62_Name" to "Dead Woods",
    "L1R62_Lore" to "",
    // Room L1R72
    "L1R72_Name" to "Logging Camp",
    "L1R72_Lore" to "Not long ago, imps emerged from the Underrealm and started to tear down the forest, leaving only logs behind. As quickly as they emerged, they returned to their dark burrow with no explanation of why they cut down an entire forest and not take a single log...",
    // Room L1R82
    "L1R82_Name" to "Hero's Blessing",
    "L1R82_Lore" to "It should not have been this way, but the final key to enter Godlair had to be hidden away, accessible only to those who would persist. But persistence alone will not be enough to grant a wish. Will you have accumulated the necessary wisdom?",
    // Room L1R03
    "L1R03_Name" to "Cobbler's Shop",
    "L1R03_Lore" to "",
    // Room L1R13
    "L1R13_Name" to "Cobbler Alley",
    "L1R13_Lore" to "",
    // Room L1R23
    "L1R23_Name" to "Sandy Dunes",
    "L1R23_Lore" to "",
    // Room L1R33
    "L1R33_Name" to "Barren Pass",
    "L1R33_Lore" to "A great war took place between two faction of an amphibian race here. As one of the faction was on the brink of defeat, they implored ancient gods to intervene. The gods, in anger at being disturbed wiped out all traces of the race in a single swipe of their sword, leaving a great chasm where their generals faced off.",
    // Room L1R43
    "L1R43_Name" to "Pit of Abaddon",
    "L1R43_Lore" to "This pit leads to the Altar of Abaddon. Long ago, victims were cast down as sacrifices to forgotten gods.",
    // Room L1R53
    "L1R53_Name" to "Cult Circle",
    "L1R53_Lore" to "The cult of Abaddon summon their dark god here and succeeded. Their bodies and souls are bound in eternal torment, being now the plaything of the very god their worshipped.",
    // Room L1R63
    "L1R63_Name" to "Doomvault",
    "L1R63_Lore" to "",
    // Room L1R73
    "L1R73_Name" to "Holy Breach",
    "L1R73_Lore" to "",
    // Room L1R83
    "L1R83_Name" to "Lava Pools",
    "L1R83_Lore" to "",
    // Room L1R04
    "L1R04_Name" to "Old Cobbler",
    "L1R04_Lore" to "",
    // Room L1R14
    "L1R14_Name" to "First Towncenter",
    "L1R14_Lore" to "",
    // Room L1R24
    "L1R24_Name" to "Desert",
    "L1R24_Lore" to "",
    // Room L1R34
    "L1R34_Name" to "Parched Cave",
    "L1R34_Lore" to "",
    // Room L1R44
    "L1R44_Name" to "River's End",
    "L1R44_Lore" to "",
    // Room L1R54
    "L1R54_Name" to "Bubbling Streams",
    "L1R54_Lore" to "",
    // Room L1R64
    "L1R64_Name" to "Elementia",
    "L1R64_Lore" to "",
    // Room L1R74
    "L1R74_Name" to "Dire Furnace",
    "L1R74_Lore" to "",
    // Room L1R84
    "L1R84_Name" to "Mangma Stream",
    "L1R84_Lore" to "",
    // Room L1R05
    "L1R05_Name" to "Defiled Grave",
    "L1R05_Lore" to "",
    // Room L1R15
    "L1R15_Name" to "Deathchill",
    "L1R15_Lore" to "",
    // Room L1R25
    "L1R25_Name" to "West Frosta",
    "L1R25_Lore" to "",
    // Room L1R35
    "L1R35_Name" to "East Frosta",
    "L1R35_Lore" to "",
    // Room L1R45
    "L1R45_Name" to "Tundra",
    "L1R45_Lore" to "",
    // Room L1R55
    "L1R55_Name" to "Respite",
    "L1R55_Lore" to "",
    // Room L1R65
    "L1R65_Name" to "Hall of Courage",
    "L1R65_Lore" to "",
    // Room L1R75
    "L1R75_Name" to "Trial of Flames",
    "L1R75_Lore" to "",
    // Room L1R85
    "L1R85_Name" to "Volcano Vent",
    "L1R85_Lore" to "",
    // Room L2R00
    "L2R00_Name" to "Mighty Chimney",
    "L2R00_Lore" to "Here is the dying magma chamber of an ancient volcano. It's vent has been cool for centuries but the magna remains deadly hot.",
    // Room L2R10
    "L2R10_Name" to "Great Oven",
    "L2R10_Lore" to "This is one of the sill of an ancient volcano. Magma remains in the chamber, making it treacherous to navigate.",
    // Room L2R20
    "L2R20_Name" to "Bastion",
    "L2R20_Lore" to "When the first races discovered war, they quickly discovered fortification. This abandoned bastion is one of the oldest fortification that remains from the Early Wars. All ancient weapons and armours have been picked cleaned by raiders over the millennia.",
    // Room L2R30
    "L2R30_Name" to "Moon Passage",
    "L2R30_Lore" to "It is said that tens of thousands of years ago, when the earth was young and the night dark, the moon tore itself from the ground and lite the night sky. This would be the cradle from which the moon arose.",
    // Room L2R40
    "L2R40_Name" to "Dark Ice Maze",
    "L2R40_Lore" to "Created by corrupt magic, giant icemoles use their massive claws to carve icy tunnels under the frigid mountain. As the magic wore out, the giant icemoles melted away back to their primordial elements, leaving behind a legacy of tunnels.",
    // Room L2R50
    "L2R50_Name" to "Mushroom Den",
    "L2R50_Lore" to "These giant mushrooms grow in total darkness and spread via motile spores that are covered in caustic mucus. The large spores wander aimlessly until it finds an adequate spot to root itself in.",
    // Room L2R60
    "L2R60_Name" to "Veiled Pass",
    "L2R60_Lore" to "",
    // Room L2R70
    "L2R70_Name" to "Treasure Chamber",
    "L2R70_Lore" to "",
    // Room L2R80
    "L2R80_Name" to "Imp Chamber",
    "L2R80_Lore" to "",
    // Room L2R01
    "L2R01_Name" to "Underriver",
    "L2R01_Lore" to "",
    // Room L2R11
    "L2R11_Name" to "Stalelake",
    "L2R11_Lore" to "",
    // Room L2R21
    "L2R21_Name" to "Fortifications",
    "L2R21_Lore" to "As the Bazaar grew, defence against marauders became a necessity. A fortress was build and house a garrison as well as served as stockpile and bank for the merchants. As the demand grew on the fortification, mechanized pathways were added to ease the movement of goods.",
    // Room L2R31
    "L2R31_Name" to "Bazaar",
    "L2R31_Lore" to "What started as a trading route quickly blossomed into a booming bazaar. For decades, merchants made their fortunes buying and selling wares until the imps moved west of here. Since then, the bazaar has been abandonned.",
    // Room L2R41
    "L2R41_Name" to "Ancient Factory",
    "L2R41_Lore" to "Before the sun lit for the first time in the sky, a race of darkness-adverse travelers can to our realm. Their only legacy is this now-dark factory and only the conveyors and a single source of light remains.",
    // Room L2R51
    "L2R51_Name" to "Forgotten Rise",
    "L2R51_Lore" to "",
    // Room L2R61
    "L2R61_Name" to "Trampled Fields",
    "L2R61_Lore" to "",
    // Room L2R71
    "L2R71_Name" to "Fetid Wells",
    "L2R71_Lore" to "Clear water is toxic to imps. They must nourish themselves from fetid earth and water. They have dug wells and filled them with refuse to create a concoction that is hearthy to them. The smell is overpowering.",
    // Room L2R81
    "L2R81_Name" to "Imp Burrows",
    "L2R81_Lore" to "",
    // Room L2R02
    "L2R02_Name" to "Merchant Way",
    "L2R02_Lore" to "Merchants from all corners of the world once travelled to the Underrealm to reach the Bazaar west of here.",
    // Room L2R12
    "L2R12_Name" to "Noble Rise",
    "L2R12_Lore" to "The world above was invaded via a rise dug under the dwellings of the nobles living above. This spelled the end of a thriving city as residents fled in horror from the dark invaders.",
    // Room L2R22
    "L2R22_Name" to "Dank Tunnels",
    "L2R22_Lore" to "",
    // Room L2R32
    "L2R32_Name" to "The Old Way",
    "L2R32_Lore" to "There are many cactus in the desert, all of them dangerous. One prick can make anyone bleed, man or imp.",
    // Room L2R42
    "L2R42_Name" to "Frozen Lake",
    "L2R42_Lore" to "Magic of corruption turned this once blue lake into a sheet of ice. One step will send anyone sliding forward. To reach your intended destination, it's best to first align oneself in the direction one wishes to go, then take a step on the ice.",
    // Room L2R52
    "L2R52_Name" to "Abandoned Fields",
    "L2R52_Lore" to "",
    // Room L2R62
    "L2R62_Name" to "Stagnant Fields",
    "L2R62_Lore" to "",
    // Room L2R72
    "L2R72_Name" to "Imp Village",
    "L2R72_Lore" to "",
    // Room L2R82
    "L2R82_Name" to "War Council",
    "L2R82_Lore" to "",
    // Room L2R03
    "L2R03_Name" to "Old Inn",
    "L2R03_Lore" to "",
    // Room L2R13
    "L2R13_Name" to "Butchery",
    "L2R13_Lore" to "",
    // Room L2R23
    "L2R23_Name" to "Dark Hall",
    "L2R23_Lore" to "",
    // Room L2R33
    "L2R33_Name" to "Hell Chasm",
    "L2R33_Lore" to "",
    // Room L2R43
    "L2R43_Name" to "Alter of Abaddon",
    "L2R43_Lore" to "Long ago, this temple was build to sacrifice victims to a forgotten god.",
    // Room L2R53
    "L2R53_Name" to "Refuge",
    "L2R53_Lore" to "Making the best of a terrible situation, a family who got trapped in the Underrealm eked out a dire existence on this farm. No traces of them remain.",
    // Room L2R63
    "L2R63_Name" to "Pit of Despair",
    "L2R63_Lore" to "",
    // Room L2R73
    "L2R73_Name" to "Spawning Pools",
    "L2R73_Lore" to "Imp are born out of fetid earth and are active from the get-go. A gigantic keeper protects the newborn imps from predators.",
    // Room L2R83
    "L2R83_Name" to "Barracks",
    "L2R83_Lore" to "For imps, war and conquest are a way of life. The build barracks to arm and train themselves before venturing out and expanding their territories.",
    // Room L2R04
    "L2R04_Name" to "The Mines",
    "L2R04_Lore" to "Men dug deep into this mine searching for valuable ore. Their initial success turned to horror as they encountered dire creatures who make their home in the dark.",
    // Room L2R14
    "L2R14_Name" to "Chittering Dark",
    "L2R14_Lore" to "",
    // Room L2R24
    "L2R24_Name" to "Sordid Cave",
    "L2R24_Lore" to "",
    // Room L2R34
    "L2R34_Name" to "Glacial River",
    "L2R34_Lore" to "",
    // Room L2R44
    "L2R44_Name" to "Molemen Turf",
    "L2R44_Lore" to "",
    // Room L2R54
    "L2R54_Name" to "Dark Ridge",
    "L2R54_Lore" to "",
    // Room L2R64
    "L2R64_Name" to "Cartography Hall",
    "L2R64_Lore" to "",
    // Room L2R74
    "L2R74_Name" to "Mechanimancer",
    "L2R74_Lore" to "",
    // Room L2R84
    "L2R84_Name" to "Shaman Lounge",
    "L2R84_Lore" to "",
    // Room L2R05
    "L2R05_Name" to "Hive",
    "L2R05_Lore" to "",
    // Room L2R15
    "L2R15_Name" to "Defiled Temple",
    "L2R15_Lore" to "",
    // Room L2R25
    "L2R25_Name" to "Unholy Hallow",
    "L2R25_Lore" to "",
    // Room L2R35
    "L2R35_Name" to "Pit Grave",
    "L2R35_Lore" to "",
    // Room L2R45
    "L2R45_Name" to "Noble Graveyard",
    "L2R45_Lore" to "",
    // Room L2R55
    "L2R55_Name" to "Sacred Mortuary",
    "L2R55_Lore" to "",
    // Room L2R65
    "L2R65_Name" to "Armoury",
    "L2R65_Lore" to "",
    // Room L2R75
    "L2R75_Name" to "Hall of Torture",
    "L2R75_Lore" to "",
    // Room L2R85
    "L2R85_Name" to "Summoning Circle",
    "L2R85_Lore" to "",
)